import { StyleSheet } from 'react-native';
import Typography from '../../../../shared/constants/Typography';

export const createCheckboxStyles = (theme: any) =>
  StyleSheet.create({
    container: {
      flexDirection: 'row',
      alignItems: Typography.textAlign.centerAlign,
      gap: Typography.gap.gap8,
    },
    checkboxMainContainer: {
      width: Typography.width.width20,
      height: Typography.height.height20,
      alignItems: Typography.textAlign.centerAlign,
      justifyContent: Typography.textAlign.centerAlign,
    },

    // ── Normal (unchecked) ────────────────────────────────────────────────
    checkboxBase: {
      backgroundColor: theme.listUnSelectedBG,
      borderColor: theme.listUnSelectedBorder,
      borderWidth: Typography.borderWidth.borderWidth012,
      width: Typography.width.width24,
      height: Typography.height.height24,
      borderRadius: Typography.radius.radius4,
      justifyContent: Typography.textAlign.centerAlign,
      alignItems: Typography.textAlign.centerAlign,
    },

    // ── Checked ───────────────────────────────────────────────────────────
    checkboxChecked: {
      backgroundColor: theme.listSelectedBG,
      borderColor: theme.listSelectedBorder,
      borderWidth: Typography.borderWidth.borderWidth012,
      width: Typography.width.width24,
      height: Typography.height.height24,
      borderRadius: Typography.radius.radius4,
      justifyContent: Typography.textAlign.centerAlign,
      alignItems: Typography.textAlign.centerAlign,
    },

    // ── Pressed (unchecked) ───────────────────────────────────────────────
    checkboxPressed: {
      backgroundColor: theme.pressedBG,
      borderColor: theme.pressedBorder,
      borderWidth: Typography.borderWidth.borderWidth012,
      width: Typography.width.width24,
      height: Typography.height.height24,
      borderRadius: Typography.radius.radius4,
      justifyContent: Typography.textAlign.centerAlign,
      alignItems: Typography.textAlign.centerAlign,
    },

    // ── Disabled (unchecked) ──────────────────────────────────────────────
    checkboxDisabled: {
      backgroundColor: theme.disabledBG,
      borderColor: theme.disabledBorder,
      borderWidth: Typography.borderWidth.borderWidth012,
      width: Typography.width.width24,
      height: Typography.height.height24,
      borderRadius: Typography.radius.radius4,
      justifyContent: Typography.textAlign.centerAlign,
      alignItems: Typography.textAlign.centerAlign,
    },

    // ── Checked + Disabled ────────────────────────────────────────────────
    checkboxCheckedDisabled: {
      backgroundColor: theme.checkedDisabledBG,
      borderColor: theme.checkedDisabledBorder,
      borderWidth: Typography.borderWidth.borderWidth012,
      width: Typography.width.width24,
      height: Typography.height.height24,
      borderRadius: Typography.radius.radius4,
      justifyContent: Typography.textAlign.centerAlign,
      alignItems: Typography.textAlign.centerAlign,
    },

    checkmark: {
      width: Typography.width.width5,
      height: Typography.height.height9,
      borderWidth: 1.5,
      borderColor: '#FFFFFF',
      borderRightWidth: 0,
      borderTopWidth: 0,
      transform: [{ rotate: '-45deg' }],
      position: Typography.position.absolute,
    },
    label: {
      color: theme.labelColor,
      fontFamily: Typography.fontFamily.inter,
      fontSize: Typography.fontSize.fontSize14,
      fontWeight: Typography.fontWeight.medium,
      alignSelf: Typography.textAlign.centerAlign,
    },
    labelDisabled: {
      opacity: 0.4,
    },
  });
